export function timeAgo(input) {
  const d = typeof input === "number" ? Date.now() - input * 1000 : new Date(input).getTime();
  const s = Math.max(0, Math.round((Date.now() - d) / 1000));
  if (s < 60) return `${s}s ago`;
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleString(undefined, {
    month: "short", day: "numeric", hour: "2-digit", minute: "2-digit", second: "2-digit",
  });
}

export function groupCode(code = "") {
  if (/^\d{6}$/.test(code)) return `${code.slice(0, 3)} ${code.slice(3)}`;
  if (/^\d{8}$/.test(code)) return `${code.slice(0, 4)} ${code.slice(4)}`;
  return code;
}

export function sourceLine(c) {
  if (c.source_type === "openphone") return `OpenPhone · from ${c.sender}`;
  if (c.source_type === "gmail") return `Gmail · ${c.source_label}${c.sender_name ? ` · ${c.sender_name}` : ""}`;
  return "Test code";
}

export const ACTIVITY_LABELS = {
  sign_in: "Signed in",
  sign_in_locked: "Locked after 5 wrong codes",
  first_admin_created: "First admin created",
  fill: "Filled a code",
  test_code_sent: "Sent a test code",
  source_connected: "Connected a source",
  source_disconnected: "Disconnected a source",
  source_updated: "Updated a source",
  source_error: "Source needs attention",
  member_added: "Added a member",
  member_removed: "Removed a member",
  member_role_changed: "Changed a role",
};
